<template>
    <v-container fill-height pa-0 id="test">
        <v-row align="center" justify="center">
            <div id="home-animated-elements" style="position: absolute; width: 200px; height: 200px;">
                <div class="home-animated-element-container">
                    <div class="home-dot-absolute"></div>
                </div>
                <div class="home-animated-element-container">
                    <div class="home-circle"></div>
                </div>
                <div class="home-animated-element-container">
                    <div class="home-dot-absolute"></div>
                </div>
                <div class="home-animated-element-container">
                    <div class="home-rectangle-large"></div>
                </div>
                <div class="home-animated-element-container">
                    <div class="home-rectangle-small"></div>
                </div>
                <div class="home-animated-element-container">
                    <v-img src="@/assets/triple_arrow_up.svg" class="home-up-arrows"></v-img>
                </div>
                <div class="home-animated-element-container">
                    <div class="home-circle"></div>
                </div>
                <div class="home-animated-element-container">
                    <div class="home-dot-absolute"></div>
                </div>
                <div class="home-dots">
                    <div v-for="i in 2" :key="i" style="display: flex;">
                        <div class="home-dot" v-for="i in 10" :key="i"></div>
                    </div>
                </div>
            </div>
            <v-card light class="py-5" max-width="450">
                <v-card-title class="pa-12">
                    <page-heading :text="$t('general.welcome')"
                                  style="width: 100%;"
                                  text-center
                    ></page-heading>
                </v-card-title>
                <v-card-text class="px-12 pb-12">
                    <div class="mb-8 d-flex justify-center" style="font-size: 18px;">
                        {{$t('general.tokentag')}}
                    </div>
                    <v-form ref="tokenForm" v-model="tokenFormIsValid">
                        <v-text-field :label="$t('components.home.token')"
                                      :rules="[rules.required]"
                                      @input="validationMessage = null"
                                      @keyup.enter="goToStart()"
                                      autocomplete="off"
                                      outlined
                                      v-model="token"
                        >
                            <!--                        <template v-slot:append-outer>-->
                            <!--                            <v-btn @click="pasteToken()"-->
                            <!--                                   icon-->
                            <!--                                   style="margin-top: -8px;"-->
                            <!--                            >-->
                            <!--                                <v-icon>mdi-content-paste</v-icon>-->
                            <!--                            </v-btn>-->
                            <!--                        </template>-->
                        </v-text-field>
                    </v-form>
                    <v-btn :disabled="!!validationMessage"
                           @click="goToStart()"
                           block
                           color="primary"
                           x-large
                    >{{$t('general.start')}}
                    </v-btn>
                </v-card-text>
                <v-card-actions class="pa-12">
                    <span class="mr-1">{{ $t('general.alreadystarted') }}</span>
                    <a @click="goToLogin()">{{$t('general.sign_in')}}</a>
                </v-card-actions>
            </v-card>
        </v-row>
    </v-container>
</template>

<script>
    import PageHeading from "../components/framework/PageHeading";
    import {TimelineMax, Sine} from 'gsap';

    export default {
        name: 'Home',
        components: {
            PageHeading
        },
        data() {
            return {
                token: '',
                validationMessage: null,
                rules: {
                    required: value => !!(value && value.length === 36 || value.split('-').length === 5) || this.$t('errors.tokeninvalid')
                },
                tokenFormIsValid: false,
                animationTimeline: null,
                displacements: [
                    {
                        x: -350,
                        y: -270,
                    },
                    {
                        x: -450,
                        y: -50,
                    },
                    {
                        x: -550,
                        y: 100,
                    },
                    {
                        x: -450,
                        y: 200,
                    },
                    {
                        x: 300,
                        y: -280,
                    },
                    {
                        x: 600,
                        y: -100,
                    },
                    {
                        x: 400,
                        y: 70,
                    },
                    {
                        x: 380,
                        y: 120,
                    }
                ],
                xMin: -50,
                xMax: 50,
                yMin: -50,
                yMax: 50,
            }
        },
        computed: {
            // tokenAutocomplete() {
            //     return new Date().toISOString();
            // }
        },
        methods: {
            goToStart() {
                if (this.$refs.tokenForm.validate()) {
                    this.$router.push({name: 'TokenStart', params: {token: this.token}});
                }
            },
            goToLogin() {
                this.$router.push({name: 'Login'});
            },
            startAnimating() {
                let coordinatesX = this.displacements.map(({x}) => x),
                    coordinatesY = this.displacements.map(({y}) => y);
                this.animationTimeline = new TimelineMax().staggerTo('.home-animated-element-container', 0, {
                    cycle: {
                        x: coordinatesX,
                        y: coordinatesY,
                    },
                }, 0);

                this.startFloating();
            },
            startFloating() {
                let positionsPerElement = 5,
                    secondsPerIteration = 10,
                    elements = document.querySelectorAll(".home-animated-element-container > *");

                for (let i = 0; i < elements.length; i++) {
                    this.randomFloat(elements[i], positionsPerElement, secondsPerIteration, i);
                }
            },
            randomFloat(element, positions, duration) {
                let tl = new TimelineMax({repeat: -1, yoyo: true, delay: Math.random() * duration});
                for (let i = 0; i < positions; i++) {
                    tl.to(element, duration, {
                        x: this.getRandomFloat(this.xMin, this.xMax),
                        y: this.getRandomFloat(this.yMin, this.yMax),
                        ease: Sine.easeInOut,
                    });
                }
                return tl;
            },
            getRandomFloat(min, max) {
                return (min + Math.random() * (max - min));
            },
            // async pasteToken() {
            //     this.token = (await navigator.clipboard.readText()).trim();
            //     this.validateToken();
            // },
            // validateToken() {
            //     this.validationMessage = null;
            //     if (this.token.length !== 36 || this.token.split('-').length !== 5) {
            //         this.validationMessage = 'errors.tokeninvalid';
            //         return false;
            //     }
            //     return true;
            // }
        },
        mounted() {
            this.startAnimating();
        }
    }
</script>

<style scoped>
    .home-dot-absolute {
        width: 7px;
        height: 7px;
        background-color: white;
        position: absolute;
        border-radius: 7px;
    }

    .home-circle {
        width: 35px;
        height: 35px;
        border: 2px solid white;
        position: absolute;
        border-radius: 100%;
    }

    .home-rectangle-large {
        width: 40px;
        height: 20px;
        border: 2px solid white;
        position: absolute;
        border-radius: 8px;
    }

    .home-rectangle-small {
        width: 30px;
        height: 15px;
        border: 2px solid white;
        position: absolute;
        border-radius: 6px;
    }

    .home-up-arrows {
        position: absolute;
        display: flex;
        flex-direction: column;
        max-width: 20px;
    }

    .home-dot {
        width: 5px;
        height: 5px;
        background-color: white;
        border-radius: 100%;
        margin: 3px;
    }

    .home-dots {
        position: absolute;
    }

    .home-animated-element-container {
        position: absolute;
        width: 200px;
        height: 200px;
        display: flex;
        justify-content: center;
        align-items: center;
        opacity: 0.3;
    }
</style>